import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

Vue.component('vue-slider', VueSlider)